"use client";

import { useEffect, useState } from "react";

interface NavigatorUAData {
  mobile: boolean;
}

function hasUserAgentData(
  nav: Navigator,
): nav is Navigator & { userAgentData: NavigatorUAData } {
  return (
    "userAgentData" in nav &&
    nav.userAgentData != null &&
    typeof nav.userAgentData === "object" &&
    "mobile" in nav.userAgentData
  );
}

/**
 * Detects if the user is on an actual mobile device (phone/tablet),
 * not based on screen width but on the device's user agent and touch capabilities.
 */
export function useIsMobileDevice() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobileDevice = () => {
      // Primary check: userAgentData API (modern browsers)
      if (hasUserAgentData(navigator)) {
        setIsMobile(navigator.userAgentData.mobile);
        return;
      }

      // Fallback: user agent string matching
      const ua = navigator.userAgent;
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

      // Also check for iPad on iOS 13+ (reports as Mac)
      const isIPad =
        navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

      setIsMobile(mobileRegex.test(ua) || isIPad);
    };

    checkMobileDevice();
  }, []);

  return isMobile;
}
